import {
  IApiEpBillingBill,
  IApiEpBillingPaymentProvider,
  IApiEpBillingRecurringPayment,
} from "@smp/api";
import { RefObject } from "react";

import { Recurring } from "./recurring";
import { Single } from "./single";

export const Cloudpayments = ({
  bill,
  onClose,
  onReachGoal,
  description,
  provider,
  recurringPayment,
  refDialog,
}: {
  onClose: (fireSuccessAction?: boolean) => void;
  onReachGoal: () => void;
  provider: IApiEpBillingPaymentProvider;
  bill?: IApiEpBillingBill;
  description?: string;
  recurringPayment?: IApiEpBillingRecurringPayment;
  refDialog?: RefObject<HTMLDivElement>;
}) => {
  if (bill) {
    return (
      <Single
        bill={bill}
        onClose={onClose}
        onReachGoal={onReachGoal}
        description={description}
        provider={provider}
        refDialog={refDialog}
      />
    );
  }

  if (recurringPayment) {
    return (
      <Recurring
        onClose={onClose}
        onReachGoal={onReachGoal}
        description={description}
        recurringPayment={recurringPayment}
        refDialog={refDialog}
      />
    );
  }

  return null;
};
